exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner-container[data-v-938d1614]{position:relative;width:100vw;height:600px;margin-left:-65px}.banner[data-v-938d1614]{position:absolute;top:-80px;right:-200px;height:100%;width:auto}.logo-container[data-v-938d1614]{color:#424242;position:absolute;left:50px;top:200px}.logo[data-v-938d1614]{width:400px;max-width:100%;height:100%;border-radius:100%;background-color:hsla(0,0%,100%,.1)}@media screen and (max-width:1400px){.banner-container[data-v-938d1614]{margin-left:-35px}.logo-container[data-v-938d1614]{left:0;right:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-938d1614","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/sections/MainBanner.vue
// module id = 406
// module chunks = 0